// MonthlyStats — KPI row, redesigned (EM handoff).
import React from 'react';
import { CalendarCheck2, Clock, Clock3, BarChart2, Coffee, TimerReset, PieChart, CalendarX } from 'lucide-react';
import { T } from '../../components/em/ui';
import { formatHoursDuration } from '../../utils/duration';

const MonthlyStats = ({ stats }) => {
  const s = stats || {};
  // `dur: true` marks a duration card — those render as "Xh Ym Zs", which is
  // wider than a plain day count, so the value drops a size to stay on one line.
  const cards = [
    { label: 'Present Days', v: s.presentDays || 0, Icon: CalendarCheck2, c: T.success600, bg: T.success50 },
    { label: 'Late Days', v: s.lateDays || 0, Icon: Clock, c: '#b45309', bg: 'rgba(251,191,36,0.12)' },
    { label: 'Half Days', v: s.halfDays || 0, Icon: PieChart, c: '#7c3aed', bg: 'rgba(124,58,237,0.12)' },
    { label: 'Absent Days', v: s.absentDays || 0, Icon: CalendarX, c: T.danger, bg: 'rgba(231,0,11,0.10)' },
    { label: 'Overtime', v: formatHoursDuration(s.otHours), dur: true, Icon: TimerReset, c: '#0d9488', bg: 'rgba(13,148,136,0.12)' },
    { label: 'Total Hours', v: formatHoursDuration(s.totalHours), dur: true, Icon: Clock3, c: T.info600, bg: T.info50 },
    { label: 'Avg Hrs/Day', v: formatHoursDuration(s.avgHours), dur: true, Icon: BarChart2, c: T.orange, bg: T.orange50 },
    { label: 'Break Hours', v: formatHoursDuration(s.totalBreakHours), dur: true, Icon: Coffee, c: T.fg5, bg: T.bgMuted },
  ];
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginTop: 12 }}>
      {cards.map((k) => (
        <div key={k.label} style={{ background: 'var(--em-bg-card)', border: `1px solid ${T.border}`, borderRadius: 14, padding: '16px 18px', boxShadow: T.shadowSm }}>
          <div style={{ width: 32, height: 32, borderRadius: 9, background: k.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
            <k.Icon size={15} color={k.c} />
          </div>
          <div style={{ font: `700 ${k.dur ? 17 : 22}px/1 ${T.font}`, color: T.fg1, letterSpacing: '-0.02em', whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{k.v}</div>
          <div style={{ font: `500 11px ${T.font}`, color: T.fg5, marginTop: 4 }}>{k.label}</div>
        </div>
      ))}
    </div>
  );
};

export default MonthlyStats;
